module.exports = __webpack_public_path__ + "img/icon1.307319ce.png";